<div class="map-layer-container" #mapContainer>
  <!-- Map fills entire container -->
  <app-sites-location-map
    #siteMap
    class="map-content"
    [projectLayersInSidenav]="true"
    [fullscreenElement]="fullscreenElement"
    [dateRange]="dateRange"
    [hoveredSiteId]="hoveredSiteId"
    [hoveredBidItemId]="hoveredBidItemId"
    [hoveredInspectorId]="hoveredInspectorId"
    [selectedSiteIds]="selectedSiteIdsForHighlight"
    [selectedBidItemIds]="selectedBidItemIdsForHighlight"
    [selectedInspectorIds]="selectedInspectorIdsForHighlight"
    [selectedDates]="selectedDatesForHighlight"
    [viewBy]="selectedViewBy"
    [bidItemsWithGeometries]="bidItemsWithGeometries"
    [availableInspectors]="availableInspectors"
    [isSingleDayMode]="isSingleDayMode"
    [labelConfig]="labelConfig"
    [linkedOnly]="linkedOnly"
    (fullscreenChange)="onFullscreenChange($event)"
    (layerChange)="onLayerChange($event)"
    (typeFilterChange)="onTypeFilterChange($event)"
    (geometryClick)="onGeometryClick($event)"
  ></app-sites-location-map>

  <!-- Floating UI elements (only visible in fullscreen) -->
  @if (isFullScreen) {
    <!-- Sidenav panel -->
    <div class="floating-sidenav-panel">
      <app-map-sidenav
          [showDesignTab]="true"
          [projectLayers]="siteMap.toolbarState"
          [canManageLayers]="siteMap.canManageProjectLayers"
          (projectLayerToggle)="siteMap.onToolbarOverlayToggle($event)"
          (projectLayerOpacity)="siteMap.onOverlayOpacityChange($event)"
          (projectLayerLabels)="siteMap.onOverlayLabelsToggle($event)"
          (projectLayerZoom)="siteMap.zoomToOverlayIfOffscreen($event)"
          (projectLayersReset)="siteMap.resetProjectLayerView()"
          (projectLayersRetry)="siteMap.refreshOverlays()"
          (projectLayerSwipe)="siteMap.onToolbarSwipePresetChange($event)"
        [projectId]="projectId"
        [filteredSites]="filteredSites"
        [availableSites]="availableSites"
        [availableBidItems]="availableBidItems"
        [bidItemsWithGeometries]="bidItemsWithGeometries"
        [selectedBidItemIds]="selectedBidItemIds"
        [isSingleDayMode]="isSingleDayMode"
        [availableInspectors]="availableInspectors"
        [selectedDate]="selectedDate"
        [layerSettings]="layerSettings"
        [initialTypeFilters]="selectedTypeFilters"
        (searchChange)="onSearchChange($event)"
        (dateChange)="onDateChange($event)"
        (viewModeChange)="onViewModeChange($event)"
        (viewByChange)="onViewByChange($event)"
        (siteHover)="onSiteHover($event)"
        (bidItemHover)="onBidItemHover($event)"
        (inspectorHover)="onInspectorHover($event)"
        (siteSelectionChange)="onSiteSelectionChange($event)"
        (bidItemSelectionChange)="onBidItemSelectionChange($event)"
        (inspectorSelectionChange)="onInspectorSelectionChange($event)"
        (dateSelectionChange)="onDateSelectionChange($event)"
        (layerChange)="onLayerChange($event)"
        (typeFilterChange)="onTypeFilterChange($event)"
        (bidItemFilterChange)="onBidItemFilterChange($event)"
        [labelsEnabled]="labelsEnabled"
        [labelBy]="labelBy"
        (labelToggle)="onLabelToggle()"
        (labelByChange)="onLabelByChange($event)"
      ></app-map-sidenav>
    </div>
  }

  <!-- Picture overlay (always available, visibility controlled by component) -->
  <app-picture-overlay></app-picture-overlay>
</div>
